import { IonCol, IonLabel, IonRow } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import { IOption } from '../../../../../common/common.types'
import SInput from '../../../../../components/stringInput/StringInput.component'
import {
  setPupilRxL,
  setPupilRxR,
  setPupilSizeL,
  setPupilSizeR,
  setHeadReactive,
  savePupils,
} from '../store/pupils.actions'
import { useDispatch, useSelector } from 'react-redux'
import { getPupilsSelector } from '../selectors/pupils.selector'
import { getDatapointsConfigSelector } from '../../../../configurations/selectors'
import { getNeuroOptionsSelector } from '../../../../options/selectors'
import Validation from '../../../../../components/validation/Validation.component'
import { PupilsConstants } from '../store/pupils.constants'

const PupilsContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const pupils = useSelector(getPupilsSelector)
  const { headReactive, pupilRxL, pupilRxR, pupilSizeL, pupilSizeR } = pupils

  const neuroOptions = useSelector(getNeuroOptionsSelector)
  const { pupilsReactOptions, pupilsSizeOptions } = neuroOptions

  const dataPointsConfig = useSelector(getDatapointsConfigSelector)
  const { DP_PUPIL_COMMENTS, DP_PUPIL_PICKLIST, DP_PUPIL_SIZELIST } = dataPointsConfig

  const save = () => {
    dispatch(savePupils())
  }

  const setPupilsLeftSizetOnChange = (option: IOption) => {
    dispatch(setPupilSizeL(option))
    save()
  }
  const setPupilsRightSizeOnChange = (option: IOption) => {
    dispatch(setPupilSizeR(option))
    save()
  }
  const setPupilsLeftReactOnChange = (option: IOption) => {
    dispatch(setPupilRxL(option))
    save()
  }
  const setPupilsRightReactOnChange = (option: IOption) => {
    dispatch(setPupilRxR(option))
    save()
  }

  const setPupilsCommentsOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setHeadReactive(e.detail.value))
    save()
  }

  return (
    <>
      <IonRow className='neuroAccordianRowHeader'>
        <IonCol size='6' className='ion-no-padding neuroAccordianColHeader'>
          <IonLabel>{t('neuro.PupilsLeft')}</IonLabel>
        </IonCol>
        <IonCol size='6' className='ion-no-padding neuroAccordianColHeader'>
          <IonLabel>{t('neuro.PupilsRight')}</IonLabel>
        </IonCol>
      </IonRow>
      {DP_PUPIL_SIZELIST === 1 && (
        <IonRow>
          <IonCol className='picklist' size={'6'}>
            <SingleSelect
              dataTestID='PupilsLeftSize'
              selectedOption={pupilSizeL}
              listHeader={t('neuro.PupilsLeftSize')}
              label={t('neuro.Size')}
              options={pupilsSizeOptions}
              action={setPupilsLeftSizetOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
          <IonCol className='picklist' size={'6'}>
            <SingleSelect
              dataTestID='PupilsRightSize'
              selectedOption={pupilSizeR}
              listHeader={t('neuro.PupilsRightSize')}
              label={t('neuro.Size')}
              options={pupilsSizeOptions}
              action={setPupilsRightSizeOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        </IonRow>
      )}
      {DP_PUPIL_PICKLIST === 1 && (
        <IonRow>
          <IonCol className='picklist' size={'6'}>
            <SingleSelect
              dataTestID='PupilsLeftReact'
              selectedOption={pupilRxL}
              listHeader={t('neuro.PupilsLeftReact')}
              label={t('neuro.React')}
              options={pupilsReactOptions}
              action={setPupilsLeftReactOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
          <IonCol className='picklist' size={'6'}>
            <SingleSelect
              dataTestID='PupilsRightReact'
              selectedOption={pupilRxR}
              listHeader={t('neuro.PupilsRightReact')}
              label={t('neuro.React')}
              options={pupilsReactOptions}
              action={setPupilsRightReactOnChange}
            />
            <hr className='field-divider' />
          </IonCol>
        </IonRow>
      )}

      {DP_PUPIL_COMMENTS === 1 && (
        <>
          <IonRow>
            <IonCol className='picklist'>
              <SInput
                isPHI
                label={t('neuro.PupilsComments')}
                dataTestID='PupilsComments'
                inputValue={headReactive}
                onChangeAction={setPupilsCommentsOnChange}
              />
              <Validation id={PupilsConstants.SET_HEADREACTIVE} />
            </IonCol>
          </IonRow>
          <hr className='field-divider' />
        </>
      )}
    </>
  )
}

export default PupilsContent
